import React, { useState } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { BfRowForm } from '../../../../Styling/styledForm/styledBlueForm'
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import styled from 'styled-components';
import colorConfig from '../../../../colorConfig';


const TableBorder = styled.div`
  border: 2px solid #ddd;
  border-radius: 4px;
  border-collapse: separate;
  border-spacing: 0;
  padding: 0 12px 0 12px;
  margin-bottom: 20px;
`

const TitleSection = styled.h3`
  font-size: 20px;
  margin: 0;
  padding-top: 12px;
  font-weight: 600;
  font-family: 'Fellix', sans-serif;
`

const RollerForm = styled(Row)`
    background-color: ${colorConfig.tabell_lysGul};  
    color: black;
    border-bottom: 0px;  
    padding: 10px 10px 0px 10px;      
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important;
`

const FriverdierTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;


    const rollerData = [
        {
          category: 'Eiendom',
          friverdi: '-1 231 998',
          amountPossessions: '2',
          missingData: '0',
        }
      ];

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('debtorName');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        rollerData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    function formatNumber(value) {
        let num = typeof value === 'number'
          ? value
          : typeof value === 'string'
            ? parseFloat(value.replace(/\s+/g, ''))
            : NaN
        if (isNaN(num)) return value
        return num
          .toFixed(num % 1 ? 2 : 0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      }

    function parseNumber(value) {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') {
          // fjern ting som kan skape krøll
          const cleaned = value.replace(/[^\d.-]+/g, '')
          const n = parseFloat(cleaned)
          return isNaN(n) ? 0 : n
        }
        // null/undefined
        return 0
    }
      

    const totals = rollerData.reduce(
    (acc, m) => ({
        friverdi:              acc.friverdi            + parseNumber(m.friverdi),
        amountPossessions:     acc.amountPossessions   + parseNumber(m.amountPossessions),
        missingData:           acc.missingData         + parseNumber(m.missingData),
    }),
    { friverdi: 0, amountPossessions: 0, missingData: 0 }
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th onClick={() => t1ChangeSortField('category', 'string')}>{localeMessages['GH_category']}{t1IndicaterIcon('category')}</th>
                  <th onClick={() => t1ChangeSortField('friverdi', 'string')}>{localeMessages['GH_friverdi']}{t1IndicaterIcon('friverdi')}</th>
                  <th onClick={() => t1ChangeSortField('amountPossessions', 'bool')}>{localeMessages['GH_amountFriverdi']}{t1IndicaterIcon('amountPossessions')}</th>
                  <th onClick={() => t1ChangeSortField('missingData', 'bool')}>{localeMessages['GH_missingData']}{t1IndicaterIcon('missingData')}</th>
              </tr>
          </thead>
      )
    }


    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <td>{model.category}</td>
               <td>{model.friverdi}</td>
               <td>{model.amountPossessions}</td>
               <td>{model.missingData}</td>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <RollerForm>
                        <Col xs={12} md={12}>
                            <TitleSection>Friverdier</TitleSection>
                            <PaginationDropdown />
                            <StyledKfTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                        {/* {printRow(rollerData)} */}
                                    </Paginate>
                                    <tr>
                                        <td><strong>Totalt</strong></td>
                                        <td>
                                            <strong>{formatNumber(totals.friverdi)}</strong>
                                        </td>
                                        <td>
                                            <strong>{formatNumber(totals.amountPossessions)}</strong>
                                        </td>
                                        <td>
                                            <strong>{formatNumber(totals.missingData)}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </StyledKfTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </RollerForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default FriverdierTable



